import { Box, MenuItem, Select, Typography, alpha } from "@mui/material";

interface YearSelectorProps {
  selectedYear?: number;
  onChange: (year?: number) => void;
  /** How many years back to show in the dropdown (default: 3) */
  range?: number;
}

/**
 * Year filter pill for the landing page — mirrors the PolicySelector visual pattern
 * (pill container with label + Select dropdown, no underline).
 */
export const YearSelector = ({ selectedYear, onChange, range = 3 }: YearSelectorProps) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: range + 1 }, (_, i) => currentYear - i);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: 1.5,
        py: 0.5,
        borderRadius: 1.5,
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
        Year:
      </Typography>
      <Select
        value={selectedYear ?? "all"}
        onChange={(e) => {
          const val = e.target.value;
          onChange(val === "all" ? undefined : Number(val));
        }}
        variant="standard"
        disableUnderline
        MenuProps={{
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          transformOrigin: { vertical: "top", horizontal: "right" },
        }}
        sx={{
          fontSize: "0.8125rem",
          fontWeight: 600,
          "& .MuiSelect-select": { py: 0, pr: 3 },
        }}
      >
        <MenuItem value="all">All Years</MenuItem>
        {years.map((year) => (
          <MenuItem key={year} value={year}>
            {year}
            {year === currentYear ? " (YTD)" : ""}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
